import { axiosGetAuthorize, axiosPost, axiosPostAuthorize } from '../AxiosRequests';
import { AddEditAdminDetails, AdminLogin,  DeleteAdminDetailsById, ForgotPassword, GetAdminDetailById, GetAdminDetailList, GetRolesForAdmin, ResetPassword } from '../ApiEndPoints';

export default class AuthenticationServicess {

    async adminLogin(request) {
        return axiosPost(AdminLogin, request);
    }
    async addEditAdminDetails(request) {
        return axiosPostAuthorize(AddEditAdminDetails, request);
    }
    async getRolesForAdmin(request) {
        return axiosGetAuthorize(GetRolesForAdmin, request);
    }
    async getAdminDetailList(request) {
        return axiosPostAuthorize(GetAdminDetailList, request);
    }
    async getAdminDetailById(request) {
        return axiosGetAuthorize(GetAdminDetailById, request);
    }
    async deleteAdminDetailsById(request) {
        return axiosPostAuthorize(DeleteAdminDetailsById, request);
    }
    async forgotPassword(request) {
        return axiosPostAuthorize(ForgotPassword, request);
    }
    async resetPassword(request) {
        return axiosPostAuthorize(ResetPassword, request);
    }
}